export default __webpack_public_path__ + "static/media/delete-white.90ce3195.png";